import React from 'react';
import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF, EXPORT_TEXT } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { DATE_RANGE_PROPS } from '../../../report-filters/report-paramter-input-properties';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_TEXT, EXPORT_CSV];

const filtersProps = [DATE_RANGE_PROPS];

const CustomersReport = () => {
  return (
    <>
      <ReportFilters filtersProps={filtersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default CustomersReport;
